export function progressBar(targetValue, currentValue) {
  return (currentValue / targetValue) * 100;
}

